export var EType;
(function (EType) {
    EType["UNKNOWN"] = "UNKNOWN";
    EType["COMBO"] = "COMBO";
    EType["PIE"] = "PIE";
    EType["DONUT"] = "DONUT";
    EType["RADAR"] = "RADAR";
    EType["FUNNEL"] = "FUNNEL";
})(EType || (EType = {}));
export var ERenderBy;
(function (ERenderBy) {
    ERenderBy["LOADING"] = "LOADING";
    ERenderBy["INIT"] = "INIT";
    ERenderBy["HOVER"] = "HOVER";
    ERenderBy["SET_SETTINGS"] = "SET_SETTINGS";
    ERenderBy["SET_DATA"] = "SET_DATA";
    ERenderBy["RESIZE"] = "RESIZE";
    ERenderBy["MOUSEMOVE"] = "MOUSEMOVE";
    ERenderBy["MOUSEOUT"] = "MOUSEOUT";
})(ERenderBy || (ERenderBy = {}));
